import StyledTextField from '@shared/components/core/field/StyledTextField';
import { hotkeyPrefix } from '@shared/constants/CommandValues';
import { IControlFieldProps } from '@shared/models/components/IControlFieldProps';
import { useTranslation } from 'react-i18next';

function HotkeyControlField({ value, onChange, disabled, ...restProps }: IControlFieldProps) {
    const { t } = useTranslation();
    value = value.replace(hotkeyPrefix, '');
    const handleChange = (value: string) => {
        value = value.replace(hotkeyPrefix, '');
        onChange('hotkey_' + value);
    };
    return (
        <StyledTextField
            fullWidth
            disabled={disabled}
            type="text"
            value={value}
            label={t('common:hotkey.label')}
            placeholder={t('common:hotkey.placeholder')}
            onChange={(e) => handleChange(e.target.value)}
            {...restProps}
        />
    );
}

export default HotkeyControlField;
